import { action, observable } from 'mobx'
import Scheduler from '@/utils/Scheduler.js'
import { format, intlFormatDistance } from 'date-fns'

export default class TimeStore {
  rootStore = null

  #scheduler = null

  @observable accessor currentTimestamp = 0
  @observable accessor currentDate = ''

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerDeconstructor(this.#_deconstructor)

    this.#scheduler = new Scheduler(this.#tick, 60 * 1000, false)
    this.#scheduler.start(true).then()
  }

  #_deconstructor = () => {
    this.#scheduler.stop()
  }

  getRelativeTime = date => intlFormatDistance(date, this.currentTimestamp)

  @action
  #tick = () => {
    this.currentTimestamp = Date.now()
    this.currentDate = format(this.currentTimestamp, 'yyyy-MM-dd')
  }
}
